import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    language: "en",
    isAuthenticated: false,
    firstAccess: false,
    checkout: false,
  },
  reducers: {
    setUser(state, { payload }) {
      state.user = payload;
      state.isAuthenticated = true;
    },
    setLanguage(state, { payload }) {
      state.language = payload;
    },
    unsetUser(state, { payload }) {
      state.user = payload.user;
      state.isAuthenticated = payload.isAuthenticated;
      state.firstAccess = false;
    },
    setFirstAccess(state, { payload }) {
      state.firstAccess = payload;
    },
    setCheckout(state, { payload }) {
      state.checkout = payload;
    },
  },
});

export const { setUser, unsetUser, setLanguage, setFirstAccess, setCheckout } = userSlice.actions;

export default userSlice.reducer;
